import { API_USER_ACTIVITIES_PATH } from "../constants/routes";
import { getRailsClient } from "../client";

export const fetchUserActivities = async (params?: { page?: number; perPage?: number }) => {
  try {
    const { data } = await getRailsClient().get(API_USER_ACTIVITIES_PATH, {
      params: params ? { page: params.page, per_page: params.perPage } : undefined,
    });
    return data;
  } catch (error) {
    console.error("Error fetching user activities:", error);
    return null;
  }
};
